export default class MessageContent {
  public constructor(value: string) {
    this._value = value;
  }

  public get value(): string {
    return this._value;
  }
  
  public fromJSON(value: string): MessageContent {
    return new MessageContent(value);
  }
  public toJSON(): string {
    return this.value;
  }
  
  public clone(): MessageContent {
    return new MessageContent(this.value);
  }

  public isEqualTo(other: MessageContent): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value;
  }

  private readonly _value: string;
}
